import React from "react";
import { Typography, alpha } from "@mui/material";

import { theme } from "../../constants";

interface ButtonProps {
  text: string;
  isActive: boolean;
  onClick: () => void;
}

const MyTradeTabButton: React.FC<ButtonProps> = ({
  text,
  isActive,
  onClick,
}) => {
  return (
    <div
      onClick={onClick}
      style={{
        color: isActive ? "black" : "white",
        borderRadius: "30px",
        background: isActive
          ? theme.colors.white
          : alpha(theme.colors.secondaryTextColor, 0.5),
        padding: "5px 15px",
      }}
    >
      <Typography variant="body2">{text}</Typography>
    </div>
  );
};

export default MyTradeTabButton;
